export default __webpack_public_path__ + "static/media/facebook-icon.0a1911de.png";